import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as yup from "yup";
import { Badge, Col, Dropdown, Image, Row } from "react-bootstrap";

import {
  declineRequestDetails,
  approveRequestDetails,
  changeRequestDetails,
} from "app/services/AdminServices/bookingService";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import config from "config.json";
import moment from "moment";
import { FcApproval } from "react-icons/fc";
import { TiTimes } from "react-icons/ti";
import { NotificationManager } from "react-notifications";
import ApproveDate from "./Components/CancelRequest/ApproveDate";
import DeclineDate from "./Components/CancelRequest/DeclineDate";
import ApproveDetails from "./Components/CancelRequest/ApproveDetails";
import DeclineDetails from "./Components/CancelRequest/DeclineDetails";
import ApproveCancel from "./Components/CancelRequest/ApproveCancel";
import DeclineCancel from "./Components/CancelRequest/DeclineCancel";
import { produce } from "immer";
import usePagePermission from "app/hooks/usePagePermission";
import HandyScroll from "app/common/Scroll";
import Tooltip from "rc-tooltip";
import { FaLongArrowAltRight } from "react-icons/fa";

const passengerValidationSchema = yup.object().shape({
  id: yup.number().required(),
  changePassengerList: yup.array().of(
    yup.object().shape({
      firstName: yup.string().required("First name is required"),
      lastName: yup.string().required("Last name is required"),
      title: yup.string().required("title is required"),
    })
  ),
});

const approveValidationSchema = yup.object().shape({
  id: yup.number().required(),
  remarks: yup.string().optional("Remarks is required"),

  cancellationCharges: yup
    .number()
    .required("Cancellation Charges is required"),
  refundAmount: yup.number().required("Refund Amount is required "),
  dateOfJourney: yup.string().optional("Refund Amount is required "),
  changePassengerList: yup.array().of(
    yup.object().shape({
      firstName: yup.string().required("First name is required"),
      lastName: yup.string().required("Last name is required"),
      title: yup.string().required("title is required"),
      gender: yup.string().required("gender is required"),
    })
  ),
});
const cancelValidationSchema = yup.object().shape({
  id: yup.number().required(),
  changePassengerList: yup.array().of(
    yup.object().shape({
      firstName: yup.string().required("First name is required"),
      lastName: yup.string().required("Last name is required"),
      title: yup.string().required("title is required"),
      gender: yup.string().required("gender is required"),
    })
  ),
});

const dateValidationSchema = yup.object().shape({
  id: yup.number().required(),
  departureDate: yup.string().required("Departure Date is required"),
});

const CancelRequest = () => {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();

  // console.log({ canAdd, canView, canEdit, canDelete });

  const { dateTimeFormat } = config;

  const [tableState, setTableState] = useState({
    page: 1,
    data: [],
    sizePerPage: 10,
    dataCount: 0,
    loading: true,
  });

  const [passengerDetails, setPassengerDetails] = useState({
    firstName: "",
    lastName: "",
    title: "",
    gender: "",
    departureDate: "",
    birthDate: "",
    selected: true,
  });

  const [lgShow, setLgShow] = useState(false);
  const [declineChangeShow, setDeclineChangeShow] = useState(false);
  const [show, setShow] = useState(false);
  const [declineCancelShow, setDeclineCancelShow] = useState(false);
  const [smShow, setSmShow] = useState(false);
  const [declineDateShow, setDeclineDateShow] = useState(false);

  const dateFormater = (cell) => {
    if (cell) {
      return (
        <>
          <div>{moment(cell).format("DD/MM/YYYY")}</div>
          <div>{moment(cell).format("HH:mm A")}</div>
        </>
      );
    }
  };
  const gatewayFormatter = (cell, row) => {
    return cell == "TRAVELPORT_GAL" ? "TRAVELPORT GAL" : cell;
  };
  const acceptRequestHandler = (row) => {
    setPassengerDetails({
      ...row,
      cancellationCharges: row?.adminCancellationCharge,
      refundAmount: row?.refundAmount,
    });
    // if (row.isPassengerChangeReq === true) {
    //   handleShows();
    // } else if (row.isTicketCancelReq === true) {
    handleShow();
    // } else if (row.isJourneyDateChangeReq === true) {
    //   handleShowSm();
    // }
  };

  const declineRequestHandler = (row) => {
    setPassengerDetails(row);
    // if (row.isPassengerChangeReq === true) {
    //   declineChangeHandleShows();
    // } else if (row.isTicketCancelReq === true) {
    declineCanceLHandleShows();
    // } else if (row.isJourneyDateChangeReq === true) {
    //   declineDateHandleShows();
    // }
  };

  const actionFormatter = (cell, row) => {
    return !row.id ? (
      <div className="container">
        <div className="row align-items-center sm">
          <div className="col-sm">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic" variant="outline-primary">
                Action
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>
                  {" "}
                  <FcApproval size={15}></FcApproval>
                  <Button
                    variant="outline"
                    size="xs"
                    style={{ width: "100%", height: "10%" }}
                    disabled
                  >
                    Approve
                  </Button>
                </Dropdown.Item>
                <Dropdown.Item>
                  <TiTimes size={15}></TiTimes>
                  <Button
                    variant="outline"
                    size="xs"
                    style={{ width: "100%", height: "10%" }}
                    disabled
                  >
                    Decline
                  </Button>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    ) : (
      <div className="container">
        <div className="row align-items-center sm">
          <div className="col-sm">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic" variant="outline-primary">
                Action
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => acceptRequestHandler(row)}>
                  <FcApproval size={20}></FcApproval>
                  <Button
                    variant="outline"
                    size="xs"
                    style={{ width: "100%", height: "10%" }}
                  >
                    Approve
                  </Button>
                </Dropdown.Item>
                <Dropdown.Item onClick={() => declineRequestHandler(row)}>
                  <TiTimes size={20}></TiTimes>
                  <Button
                    variant="outline"
                    size="xs"
                    style={{ width: "100%", height: "10%" }}
                  >
                    Decline
                  </Button>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    );
  };

  const requestFormatter = (cell, row) => {
    if (row.changePassengerList[0].requestType === "CHANGE_PASSANGER") {
      return "CHANGE PASSENGER";
    }
    if (row.changePassengerList[0].requestType === "CANCEL_TICKET") {
      return "CANCEL TICKET";
    }
    if (row.changePassengerList[0].requestType === "CHANGE_DOJ") {
      return "CHANGE DATE OF JOURNEY";
    }
  };

  // changeModal

  const handleCloses = () => {
    setLgShow(false);
  };

  const handleShows = () => {
    setLgShow(true);
  };

  //  decline change modal

  const declineChangeHandleCloses = () => {
    setDeclineChangeShow(false);
  };

  const declineChangeHandleShows = () => {
    setDeclineChangeShow(true);
  };
  const submitPassengerHandler = async (values) => {
    let approveBookingReq = {};
    approveBookingReq.requestType = "CHANGE_PASSANGER";
    approveBookingReq.bookingDetailId = values.id;
    approveBookingReq.remarks = values.remarks;
    approveBookingReq.bookedPassengerList = [];

    values.changePassengerList.forEach((item) => {
      let passenger = {
        passangerId: item.id,
        passengerType: item.passengerType,
        title: item.title,
        firstName: item.firstName,
        lastName: item.lastName,
        gender: item.gender,
        birthDate: item.birthDate,
      };
      approveBookingReq.bookedPassengerList.push(passenger);
    });

    const submitData = await approveRequestDetails(approveBookingReq);
    try {
      setLgShow(false);
      if (submitData.status == "Success") {
        NotificationManager.success(submitData.message);
      } else {
        NotificationManager.error(submitData.message);
      }
      setTableState({
        ...tableState,
        page: 1,
      });
      setTimeout(async () => {
        await loadChangeRequest();
      }, 10);
    } catch (error) {
      NotificationManager.error(error);
    }
  };
  const declinePassengerHandler = async (values) => {
    let declineBookingReq = {};
    declineBookingReq.requestType = "CHANGE_PASSANGER";
    declineBookingReq.bookingDetailId = values.id;
    declineBookingReq.remarks = values.remarks;
    declineBookingReq.bookedPassengerList = [];

    values.changePassengerList.forEach((item) => {
      let passenger = {
        passangerId: item.id,
        passengerType: item.passengerType,
        title: item.title,
        firstName: item.firstName,
        lastName: item.lastName,
        gender: item.gender,
        birthDate: item.birthDate,
      };
      declineBookingReq.bookedPassengerList.push(passenger);
    });
    const submitData = await declineRequestDetails(declineBookingReq);
    try {
      setDeclineChangeShow(false);
      if (submitData.status == "Success") {
        NotificationManager.success(submitData.message);
      } else {
        NotificationManager.error(submitData.message);
      }
      setTableState({
        ...tableState,
        page: 1,
      });
      setTimeout(async () => {
        await loadChangeRequest();
      }, 10);
    } catch (error) {
      NotificationManager.error(error);
    }
  };

  // cancelModal

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  //  decline cancel modal

  const declineCanceLHandleCloses = () => {
    setDeclineCancelShow(false);
  };

  const declineCanceLHandleShows = () => {
    setDeclineCancelShow(true);
  };

  // Datemodal

  const handleCloseSm = () => {
    setSmShow(false);
  };

  const handleShowSm = () => {
    setSmShow(true);
  };

  //  decline date modal

  const declineDateHandleCloses = () => {
    setDeclineDateShow(false);
  };

  const declineDateHandleShows = () => {
    setDeclineDateShow(true);
  };
  const declineDateHandler = async (values) => {
    let declineDateBookingReq = {};
    declineDateBookingReq.requestType = "CHANGE_DOJ";
    declineDateBookingReq.bookingDetailId = values.id;
    declineDateBookingReq.remarks = values.remarks;
    declineDateBookingReq.dateOfJourney = values.departureDate;
    declineDateBookingReq.bookedPassengerList = [];

    let passenger = {};
    declineDateBookingReq.bookedPassengerList.push(passenger);

    const submitData = await declineRequestDetails(declineDateBookingReq);
    try {
      setDeclineDateShow(false);
      if (submitData.status == "Success") {
        NotificationManager.success(submitData.message);
      } else {
        NotificationManager.error(submitData.message);
      }
      setTableState({
        ...tableState,
        page: 1,
      });
      setTimeout(async () => {
        await loadChangeRequest();
      }, 10);
    } catch (error) {
      NotificationManager.error(error);
    }
  };
  const pnrFormatter = (row) => {
    return (
      <>
        <Tooltip placement="top" overlay={<div>{row}</div>}>
          <span>
            <Button variant="outline-primary" size="sm">
              Check PNR
            </Button>
          </span>
        </Tooltip>
      </>
    );
  };
  const flightFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <>
        <Tooltip
          placement="top"
          overlay={
            <div style={{ maxWidth: 250 }}>
              {row.airportDeparture.cityName} <FaLongArrowAltRight />{" "}
              {row.airportDestination.cityName}
            </div>
          }
        >
          <span>
            {row.airportDeparture.cityCode} <FaLongArrowAltRight />{" "}
            {row.airportDestination.cityCode}
          </span>
        </Tooltip>
      </>
    );
  };
  const JourneyType = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <div>
        {row.journeyType == 1 ? (
          <>
            <div style={{ marginBottom: 5 }}>
              {row.flightCarrier.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row.flightCarrier.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                      alt=""
                      height="20"
                      width={"20"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row.flightCarrier.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                    alt=""
                    height="20"
                    width={"20"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row.flightCarrier.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg={row.isDomestic == true ? "info" : "danger"}>
                {row.isDomestic == true ? "Domestic" : "International"} Oneway
              </Badge>
            </h6>
          </>
        ) : row.journeyType == 2 ? (
          <>
            <div style={{ marginBottom: 5, borderRadius: 15 }}>
              {row.flightCarrier.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row.flightCarrier.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                      alt=""
                      height="20"
                      width={"20"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row.flightCarrier.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                    alt=""
                    height="20"
                    width={"20"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row.flightCarrier.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg="warning" style={{ color: "black" }}>
                Domestic Return
              </Badge>
            </h6>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 5 }}>
              {row.flightCarrier.flightCarrierName.length > 10 ? (
                <Tooltip
                  placement="top"
                  overlay={
                    <div style={{ maxWidth: 250 }}>
                      {row.flightCarrier.flightCarrierName}
                    </div>
                  }
                >
                  <span>
                    <Image
                      src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                      alt=""
                      height="22"
                      width={"22"}
                      style={{ marginRight: 3, borderRadius: 15 }}
                    />

                    {row.flightCarrier.flightCarrierName.substring(0, 10) +
                      "..."}
                  </span>
                </Tooltip>
              ) : (
                <div>
                  <Image
                    src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
                    alt=""
                    height="22"
                    width={"22"}
                    style={{ marginRight: 3, borderRadius: 15 }}
                  />
                  {row.flightCarrier.flightCarrierName}
                </div>
              )}
            </div>
            <h6>
              <Badge bg="primary">International Return</Badge>
            </h6>
          </>
        )}
      </div>
    );
  };
  const userType = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <>
        <Row>
          <Col>
            <div style={{ fontWeight: "bold" }}>{row?.user?.lastName}</div>
            <div>{row.user.normalizedUserName}</div>
            <div>{row?.user?.firstName}</div>
          </Col>
        </Row>
      </>
    );
  };
  const DateAndTime = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <>
        <div>
          {moment(row.changePassengerList[0].requestDate).format("DD-MM-YYYY")}
        </div>
        <div>
          {moment(row.changePassengerList[0].requestDate).format("hh:mm a")}
        </div>
      </>
    );
  };
  const columns = [
    // {
    //   dataField: "user.normalizedUserName",
    //   text: "User Name",
    //   headerStyle: () => {
    //     return {
    //       width: "80px",
    //       textAlign: "center",
    //     };
    //   },
    // },
    {
      dataField: "id",
      text: "Action",
      formatter: actionFormatter,
      headerStyle: () => {
        return {
          width: "90px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "user.normalizedUserName",
      text: "User",
      headerStyle: (colum, colIndex) => {
        return { width: "180px", textAlign: "center" };
      },
      formatter: userType,
    },
    {
      dataField: "changePassengerList",
      text: "Request Date & Time",
      headerStyle: (colum, colIndex) => {
        return { width: "180px", textAlign: "center" };
      },
      formatter: DateAndTime,
    },

    {
      dataField: "journeyType",
      text: "Airlines",
      formatter: JourneyType,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "airportDeparture.cityCode",
      text: "From - To",
      formatter: flightFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },
    {
      dataField: "pnr",
      text: "PNR",
      formatter: pnrFormatter,
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "departureDate",
      text: "Departure Date",
      formatter: dateFormater,
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "arrivalDate",
      text: "Arrival Date",
      formatter: dateFormater,
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "requestType",
      text: "Request Type ",
      formatter: requestFormatter,
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
    },
    // {
    //   dataField: "departureTime",
    //   text: "Departure Time",
    //   headerStyle: () => {
    //     return {
    //       width: "100px",
    //       textAlign: "center",
    //     };
    //   },
    // },
    {
      dataField: "apiGateway",
      text: "Gateway",

      headerStyle: (colum, colIndex) => {
        return { width: "110px", textAlign: "center" };
      },
      formatter: gatewayFormatter,
    },
    {
      dataField: "refundStatus",
      text: "Refund Status",
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
  ];

  const rowStyle = (row) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";

    style.verticalAlign = "center";
    if (row.currentStatus === "REJECTED") {
      style.backgroundColor = "#DCDCDC";
    }
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadChangeRequest = async () => {
    const { page, sizePerPage } = tableState;

    const response = await changeRequestDetails();

    const data = response.data.data;

    const pagingData = JSON.parse(response.headers["x-pagination"]);

    setTableState(
      produce((draft) => {
        draft.page = pagingData?.CurrentPage;
        draft.data = data;
        draft.sizePerPage = pagingData?.PageSize;
        draft.dataCount = pagingData?.TotalCount;
        draft.loading = false;
      })
    );
  };

  useEffect(() => {
    loadChangeRequest();
  }, []);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setTableState(() => ({
      ...tableState,
      page,
      sizePerPage,
    }));
    setTimeout(async () => {
      await loadChangeRequest();
    }, 10);
  };

  const refreshFilter = async () => {
    loadChangeRequest();
  };
  const submitDateHandler = async (values) => {
    let dateBookingReq = {};
    dateBookingReq.requestType = "CHANGE_DOJ";
    dateBookingReq.bookingDetailId = values.id;
    dateBookingReq.remarks = values.remarks;
    dateBookingReq.dateOfJourney = values.changePassengerList[0].dateOfJourney;
    dateBookingReq.bookedPassengerList = [];

    let passenger = {};
    dateBookingReq.bookedPassengerList.push(passenger);
    console.log(values.dateOfJourney);
    const submitData = await approveRequestDetails(dateBookingReq);
    try {
      setSmShow(false);
      if (submitData.status == "Success") {
        NotificationManager.success(submitData.message);
      } else {
        NotificationManager.error(submitData.message);
      }
      setTableState({
        ...tableState,
        page: 1,
      });
      setTimeout(async () => {
        await loadChangeRequest();
      }, 10);
    } catch (error) {
      NotificationManager.error(error);
    }
  };

  const { data, dataCount, loading } = tableState;

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="me-2">Page Size</label>
      <div className="btn-group me-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <div>
        <Helmet>
          <title>Cancel Request</title>
        </Helmet>
        <Breadcrumb routeSegments={[{ name: "Cancel Request" }]}></Breadcrumb>

        <div className="card card-body text-left " id="bookingHistory">
          <div>
            <div className="row mb-2 me-1 float-end">
              <button
                className="btn btn-lg btn-primary "
                onClick={() => refreshFilter()}
              >
                Refresh
              </button>
            </div>

            {/* Date Change */}
            {/* <ApproveDate
              submitDateHandler={submitDateHandler}
              validationSchema={dateValidationSchema}
              initialValues={passengerDetails}
              approveDateShow={smShow}
              handleCloseSm={handleCloseSm}
            /> */}

            {/*Decline Date Change */}

            {/* <DeclineDate
              declineDateHandler={declineDateHandler}
              validationSchema={dateValidationSchema}
              initialValues={passengerDetails}
              declineDateShow={declineDateShow}
              declineDateHandleCloses={declineDateHandleCloses}
            /> */}
            {/* Change request  */}

            {/* <ApproveDetails
              submitPassengerHandler={submitPassengerHandler}
              validationSchema={passengerValidationSchema}
              initialValues={passengerDetails}
              approveDetailsShow={lgShow}
              approveDetailsHandleCloses={handleCloses}
            /> */}
            {/*DECLINE  Change request  */}

            {/* <DeclineDetails
              declinePassengerHandler={declinePassengerHandler}
              validationSchema={passengerValidationSchema}
              initialValues={passengerDetails}
              declineDetailsShow={declineChangeShow}
              declineDetailsHandleCloses={declineChangeHandleCloses}
            /> */}
            {/* Cancel flight */}

            <ApproveCancel
              // submitCancelHandeler={submitCancelHandeler}
              validationSchema={approveValidationSchema}
              initialValues={passengerDetails}
              show={show}
              handleClose={handleClose}
              loadChangeRequest={loadChangeRequest}
              setShow={setShow}
            />

            {/* decline  Cancel flight */}

            <DeclineCancel
              // declineCancelHandeler={declineCancelHandeler}
              validationSchema={cancelValidationSchema}
              initialValues={passengerDetails}
              show={declineCancelShow}
              handleClose={declineCanceLHandleCloses}
              setDeclineCancelShow={setDeclineCancelShow}
              loadChangeRequest={loadChangeRequest}
            />
          </div>
          <HandyScroll>
            <div
              class="spacious-container"
              data-handy-scroll
              style={{ overflow: "auto" }}
            >
              <BootstrapTable
                hover
                remote
                keyField="id"
                data={data}
                columns={
                  canEdit ? columns : columns.filter((x) => x.text !== "Action")
                }
                pagination={paginationFactory(paginationOptions)}
                onTableChange={handleTableChange}
                noDataIndication={() => <NoDataIndication />}
                loading={loading}
                headerClasses="bg-primary text-white"
                bodyClasses="react-bootstrap-table-next-min-height"
                rowStyle={rowStyle}
              />
            </div>
          </HandyScroll>
        </div>
      </div>
    </>
  );
};

export default CancelRequest;
